import ButtonIcon from "@visa/vds/button-icon";
import Icon from "@visa/vds/icon";
import Link from "@visa/vds/link";
import Typography from "@visa/vds/typography";
import { LibraryPostFileClickAction } from "_constants/GlobalConstants";
import { LibraryPostType } from "_constants/LibraryConstants";
import Tooltip from "rc-tooltip";
import React from "react";

const SearchResultItem = (props) => {
    const item = props.item;
    const iconNames = ["document", "global", "link", "document", "document-pdf", "document-xls", "document-zip", "document-jpg"];
    let iconName = "document";
    if (item.type < iconNames.length) {
        iconName = iconNames[item.type];
    }

    const onClickItem = (e, item) => {
        e.preventDefault();
        switch (item.type) {
            case 2:
                props.handleClickItem(item, LibraryPostType.Url, LibraryPostFileClickAction.Link);
                break;
            case 3: case 4: case 5: case 6: case 7:
                props.handleClickItem(item, LibraryPostType.File, LibraryPostFileClickAction.Download);
                break;
            default:
                break;
        }
    }

    return (
        <div className="search-result-item-box">
            <Icon className="search-result-item-type" name={iconName} resolution="high" />
            <div className="search-result-item-info">
                <Link inline className="search-result-item-title"
                    onClick={(e) => onClickItem(e, item)}>
                    {item.title}
                </Link>
                <div className="search-result-item-metadata">
                    {item.libraryClassificationId &&
                        <>
                            <div>
                                <Icon name="category" resolution="tiny" />
                            </div>
                            <div className="text">
                                {item.libraryClassificationName}
                            </div>
                            {item.libraryClassificationId === 3 &&
                                <div className="search-item-result-subscription-tooltip">
                                    <Tooltip
                                        placement="right"
                                        overlay={
                                            <span>{item.productName ? item.productName : ""}</span>
                                        }
                                    >
                                        <ButtonIcon
                                            ariaLabel="store-open"
                                            iconType="light-tiny"
                                        >
                                            <Icon name="info" resolution="tiny" />
                                        </ButtonIcon>
                                    </Tooltip>
                                </div>
                            }
                        </>
                    }
                    {item.updatedOn && <div className="text">Updated On: {item.updatedOn}</div>}
                </div>
                <Typography className="search-result-item-desc">{item.description}</Typography>
            </div>
        </div >
    );
}

export default SearchResultItem;